import { GET_CUSTOMER_PRICE, UPDATE_CUSTOMER_BALANCE } from 'api/graphql/user';
import { sanitize } from 'api/utils';
import Model from '../model';
import { parseShape } from '../model/utils';

const updateBalanceTypes = {
    code: String,
    phone: String
}
export const updateCustomerBalance = (variables) => {
    return Model.apollo.mutate({
        mutation: UPDATE_CUSTOMER_BALANCE,
        variables: sanitize(variables, updateBalanceTypes)
    }).then((response) => {
        return processUpdateBalanceResponse(response);
    })
}

const processUpdateBalanceResponse = (response) => {
    const error = response['data']?.['updateCustomerBalance']?.['error'];
    const newBalance = response['data']?.['updateCustomerBalance']?.['customer']?.['balance'];
    return {
        error,
        newBalance
    }
}

const customerPriceTypes = {
    phone: String,
    service: String,
    visits: Number
}

export const getCustomerPrice = (variables) => {
    return Model.apollo.query( {
        query: GET_CUSTOMER_PRICE,
        variables: sanitize(variables, customerPriceTypes)
    }).then(( response ) => {
        return parseShape(response.data?.['customerPrice']?.[0]?.['price']);
    } ).catch( ( err ) => {
        console.error(err);
        return `Произошла ошибка ${ err }`
    });
}
